/*eslint-disable */
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');

export default {
  name: 'assignment-description',
  components: {},
  props: {
    showDescription: {
      type: Boolean
    }
  },
  data() {
    return {
      showForm: false
    }
  },
  computed: {

  },
  mounted() {
    $(document).ready(function() {
      $('.accordion .accordion-title').on('click', function() {
        $(this).siblings('.accordion-content').toggleClass('show');
      })
    })
  },
  methods: {
    showBlogDescription() {
      this.$emit('showDescription', true);
    }
  },
  updated() {
    console.log('updated' + this.showForm);
  },
  beforeCreate: function() {
    document.title = ' Oddvega - Assignment ';
  },
  beforeRouteLeave: function(to, from, next) {
    document.title = ' Oddvega ';
    next();
  }
}